import { radius, spacing, colors } from '@mehilainen/mds-tokens';
import { baseTypography } from '@mehilainen/mds-tokens/typography';
// https://zeroheight.com/095c4083c/v/latest/p/734594-customer
export const customerTokens = {
    uiElementTypography: {
        dropdownRow: baseTypography.size[300].rem,
        selectorModalTitle: baseTypography.size[300].rem,
        datePickerDate: baseTypography.size[300].rem,
        datePickerColumenTitle: baseTypography.size[200].rem,
    },
    uiElementButton: {
        sizeSmall: {
            fontSize: baseTypography.size[200].rem,
            height: '32px',
            squareBorderRadius: radius[200].pixels,
        },
        sizeMedium: {
            fontSize: baseTypography.size[300].rem,
            height: '40px',
            squareBorderRadius: radius[200].pixels,
        },
        sizeLarge: {
            fontSize: baseTypography.size[300].rem,
            height: '48px',
            squareBorderRadius: radius[200].pixels,
        },
    },
    uiElementInputFields: {
        sizeSmall: {
            labelFontSize: baseTypography.size[300].rem,
            labelFontWeight: baseTypography.weight.Medium,
            contentFontSize: baseTypography.size[300].rem,
            assistiveTextSize: baseTypography.size[300].rem,
            assistiveTextWeight: baseTypography.weight.Regular,
            height: '40px',
        },
        sizeMedium: {
            labelFontSize: baseTypography.size[300].rem,
            labelFontWeight: baseTypography.weight.Medium,
            contentFontSize: baseTypography.size[400].rem,
            assistiveTextSize: baseTypography.size[300].rem,
            assistiveTextWeight: baseTypography.weight.Regular,
            height: '56px',
        },
        common: {
            borderRadius: radius[100].pixels,
            borderColor: 'Gray500',
            labelFilledColor: 'Gray900',
            paddingLeft: 16,
        },
    },
    uiElementSelections: {
        iconSize: '32px',
        toggleWidth: '32px',
        toggleHeight: '19px',
        thumbSize: '11.5px',
        labelMarginLeft: spacing[400].px,
        labelSize: baseTypography.size[400].rem,
        labelWeight: baseTypography.weight.Regular,
        subLabelSize: baseTypography.size[300].rem,
        subLabelWeight: baseTypography.weight.Regular,
    },
    uiElementChips: {
        sizeSmall: {
            height: '24px',
            fontSize: baseTypography.size[300].rem,
            padding: '8px',
        },
        sizeMedium: {
            height: '40px',
            fontSize: baseTypography.size[300].rem,
            padding: '16px',
        },
    },
    uiElementToggleButton: {
        sizeSmall: {
            height: '32px',
            fontSize: baseTypography.size[200].rem,
            padding: '8px',
        },
        sizeMedium: {
            height: '40px',
            fontSize: baseTypography.size[300].rem,
            padding: '8px',
        },
        sizeLarge: {
            height: '56px',
            fontSize: baseTypography.size[300].rem,
            padding: '16px',
        },
    },
    uiElementTabs: {
        fontSize: baseTypography.size[300].rem,
        lineColor: 'Primary500',
    },
    uiElementAlert: {
        borderRadius: radius[200].rem,
        border: '1px solid',
        borderSuccessColor: colors.Success200,
        borderErrorColor: colors.Error200,
        borderInfoColor: colors.Info200,
        borderWarningColor: colors.Attention200,
        textColor: '800',
        iconColor: '500',
    },
    uiElementAccordion: {
        titleFontSize: baseTypography.size[500].rem,
        contentDefaultFontSize: baseTypography.size[400].rem,
        iconSize: '32px',
        height: '64px',
    },
    values: {
        inputLabelPlacement: 'standard',
    },
};
